<template>
  <d-container fluid class="main-content-container p-4">
    <d-card title="Exporter les comptes" class="card-small">
      <d-card-header>
        <h3 class="text-center">Exporter les transactions</h3>
      </d-card-header>
      <d-card-body>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input type="select" label="Format d'export" :options="exportFormatOptions" v-model="export_format"/>
            <c-input type="select" label="Séparateur" :options="exportDelimiterOptions" v-model="export_delimiter"/>
<!--            <c-input type="number" label="Nombre max de transactions(s)" v-model="export_limit"-->
<!--                     :state="export_limit_state">-->
<!--              Veuillez saisir un nombre positif ou laissez vide-->
<!--            </c-input>-->
          </d-col>
          <d-col class="ml-2">
            <c-input type="select" label="Transactions à exporter" :options="exportTransactionTypeOptions"
                     v-model="export_transaction_type"/>
            <c-input type="select" label="Statuts à exporter" :options="exportTransactionStatusOptions"
                     v-model="export_transaction_status"/>
            <c-input type="datetime" label="Depuis le (inclus)" v-model="export_from_datetime"
                     :state="export_from_datetime_state">
              Veuillez entrer la date et l'heure de début
            </c-input>
            <c-input type="datetime" label="Jusqu'au (inclus)" v-model="export_to_datetime"
                     :state="export_to_datetime_state">
              Veuillez entrer la date et l'heure de fin
            </c-input>
          </d-col>
        </d-form-row>
      </d-card-body>
      <d-card-footer>
        <d-input-group class="justify-content-center">
          <c-input
            type="filename" class="w-50" placeholder="Nom du fichier"
            :value="export_filename" :extension="export_extension" :state="export_filename_state" disabled
          >
            Veuillez saisir un nom de fichier valide
          </c-input>
          <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetching" @click="onDownload">
            <template slot="icon"><i class="fa fa-download"></i></template>
            Télécharger
          </c-button-spinner>
          <vue-json-csv ref="csv" :data="export_data" :name="csvFilename" :delimiter="export_delimiter">
            <span></span>
          </vue-json-csv>
        </d-input-group>
      </d-card-footer>
    </d-card>
  </d-container>
</template>

<script>
import VueJsonCsv from "vue-json-csv"
import { Api, DateFormatter, Regex, Toast } from "@/helpers"

export default {
  title: "Exporter les transactions",
  components: { VueJsonCsv },
  data() {
    return {
      fetching: false,
      submitted: false,

      export_data: [],
      export_transaction_type: "PAYIN",
      export_transaction_status: "SUCCESS",
      export_from_datetime: DateFormatter.todayStart(),
      export_to_datetime: DateFormatter.todayEnd(),
      export_format: "CSV",
      export_delimiter: ";",
      // export_limit: "",
    }
  },
  computed: {
    export_filename() {
      return `Campost-Payment_Transactions_${this.export_transaction_type}_${DateFormatter.forFilename()}`
    },
    csvFilename() {
      return `${this.export_filename}${this.export_extension}`
    },
    exportFormatOptions() {
      return [{
        text: "CSV",
        value: "CSV",
      }]
    },
    exportDelimiterOptions() {
      return [{
        text: ";",
        value: ";",
      }, {
        text: ",",
        value: ",",
      }]
    },
    exportTransactionTypeOptions() {
      return [{
        text: "Paiements entrants",
        value: "PAYIN",
      }, {
        text: "Paiements sortants",
        value: "PAYOUT",
      }]
    },
    exportTransactionStatusOptions() {
      return [
        {
          text: "Tous les statuts",
          value: "ALL",
        },
        {
          text: "Transactions réussies",
          value: "SUCCESS",
        },
        {
          text: "Transactions échoués",
          value: "FAILED",
        },
      ]
    },
    export_extension() {
      return ".csv"
    },
    export_from_datetime_state() {
      return !this.submitted || Regex.isDatetime(this.export_from_datetime)
    },
    export_to_datetime_state() {
      return !this.submitted || Regex.isDatetime(this.export_to_datetime)
    },
    export_filename_state() {
      return !this.submitted || Regex.isValidFilename(this.export_filename)
    },
    // export_limit_state() {
    //   return !this.submitted || Regex.isEmptyOrStrictPositiveInteger(this.export_limit)
    // },
  },
  methods: {
    isFormValid() {
      return Regex.isDatetime(this.export_from_datetime)
        && Regex.isDatetime(this.export_to_datetime)
        && Regex.isValidFilename(this.export_filename)
        // && Regex.isEmptyOrStrictPositiveInteger(this.export_limit)
    },
    onDownload() {
      this.submitted = true

      if (!this.isFormValid()) return

      this.fetching = true
      Api.postFormData("/transaction/dump", {
        transaction_type: this.export_transaction_type,
        transaction_status: this.export_transaction_status,
        from_datetime: this.export_from_datetime,
        to_datetime: this.export_to_datetime,
        format: this.export_format,
        separator: this.export_delimiter,
      })
        .then(res => {
          this.export_data = res.data.transactions
          if (!this.export_data.length)
            Toast.info("Aucune transaction trouvée")
          else {
            Toast.loading(`Génération du fichier ${this.export_format}...`)
            setTimeout(() => {
              Toast.loadingToast.goAway()
              this.$refs.csv.generate()
            }, 2000)
          }
        })
        .catch(err => this.error = err)
        .then(() => this.fetching = false)
    },
  },
}
</script>

<style scoped>
</style>
